import React from 'react'
import { useAuth0 } from '@auth0/auth0-react';
import { Button } from 'react-bootstrap';

const LogoutButton = () => {
  const { logout } = useAuth0();         
  return (
    <Button 
      variant="outline-primary" 
      size="sm" 
      className="rounded-pill px-3" 
      onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
    >
      <i className="bi bi-box-arrow-right me-1"></i>
      Log out
    </Button>
  )
}

export default LogoutButton